import LoadingButton from 'components/Common/LoadingButton';
import { axiosbaseurl } from 'configure';
import { setUpdatedData } from 'helpers/data_setters';
import React, { useEffect, useState } from 'react'
import { Modal, ModalBody } from "reactstrap"


const EditStatusMaster = ({ show, setShow, settable_data, statusId, setStatusId, api_name, type }) => {

    // Individual states for each field
    const [statusName, setStatusName] = useState("");
    const [colorCode, setColorCode] = useState("#40a676");
    const [sortOrder, setSortOrder] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // get existing data
    useEffect(() => {
        const getStatus = async () => {
            try {
                setLoading(true)
                const response = await axiosbaseurl.get(`/${api_name}/${statusId}`);
                if (response.data.success) {
                    setStatusName(response.data.data.statusName)
                    setColorCode(response.data.data.colorCode)
                    setSortOrder(response.data.data.sortOrder)
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        if (statusId)
            getStatus()
    }, [statusId])

    useEffect(() => {
        if (!show) {
            setStatusName("")
            setColorCode("#40a676")
            setSortOrder("")
            setStatusId("")
            setError("")
        }
    }, [show])

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            if (statusName && colorCode && sortOrder) {
                setLoading(true)
                const response = await axiosbaseurl.put(`/${api_name}/${statusId}`, {
                    statusName,
                    colorCode,
                    sortOrder
                });

                if (response.data.success) {
                    settable_data(prev => setUpdatedData(prev, response.data.data, "edit"))
                    setShow(false)
                }

            } else {
                setError("All Fields Required")
            }
        } catch (error) {
            setError(error?.response?.data?.error?.errors[0]?.message || error?.response?.data?.message || error.message)
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal size="lg" isOpen={show} toggle={() => setShow(!show)} centered={true}>
            <div className="modal-content">
                <ModalBody className="px-3 ">
                    <div className='d-flex justify-content-between'>
                        <h5>Edit {type} Status</h5>
                        <button type="button" className="btn-close " onClick={() => setShow(!show)}></button>
                    </div>
                    <div>
                        {
                            error && <div className="alert alert-danger">{error}</div>
                        }
                    </div>
                    <form onSubmit={handleSubmit} className='mt-4'>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label>Sort Order <span className='text-danger'>*</span></label>
                                    <input
                                        type="number"
                                        placeholder='Enter Sort Order '
                                        value={sortOrder}
                                        onChange={(e) => setSortOrder(e.target.value)}
                                        className="form-control input-field"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label>Color Code <span className='text-danger'>*</span></label>
                                    <div className='d-flex align-items-center'>
                                        <input
                                            type="text"
                                            placeholder='Enter Color Code'
                                            value={colorCode}
                                            onChange={(e) => setColorCode(e.target.value)}
                                            className="form-control input-field"
                                            required
                                        />
                                        <input
                                            type="color"
                                            value={colorCode}
                                            style={{ height: '44px' }}
                                            onChange={(e) => setColorCode(e.target.value)}
                                            className="form-control py-1 px-1 w-25 mb-0 input-field"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>


                            <div className="col-12">
                                <div className="mb-3">
                                    <label>Status Name <span className='text-danger'>*</span></label>
                                    <input
                                        type="text"
                                        placeholder='Enter Status Name '
                                        value={statusName}
                                        onChange={(e) => setStatusName(e.target.value.trimStart())}
                                        className="form-control input-field"
                                        required
                                    />
                                </div>
                            </div>


                        </div>

                        <div className='text-center mt-4'>
                            <LoadingButton loading={loading} />
                        </div>

                    </form>

                </ModalBody>
            </div>
        </Modal>
    )
}

export default EditStatusMaster;